import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TCampaign, TQueryOptions } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class CampaignsService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TCampaign[]> {
        const path = this.firestorePathsService.getCampaignsPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TCampaign[]>;
        return observable;
    }

    public async getByUid(uid: string): Promise<TCampaign> {
        const collection = this.firestorePathsService.getCampaignsPath();
        return this.firestoreService.getByUid(collection, uid) as Promise<TCampaign>;
    }

    public async getAll(): Promise<TCampaign[]> {
        const collection = this.firestorePathsService.getCampaignsPath();
        return this.firestoreService.getAll(collection) as Promise<TCampaign[]>;
    }

    public async add(campaign: TCampaign): Promise<TCampaign> {
        const collection = this.firestorePathsService.getCampaignsPath();
        return this.firestoreService.add(collection, campaign) as Promise<TCampaign>;
    }

    // This is a reverse sort
    public sort(campaigns: TCampaign[]): TCampaign[] {
        campaigns.sort((a: TCampaign, b: TCampaign) => {
            if (a.sentDate < b.sentDate) {
                return 1;
            } else if (a.sentDate > b.sentDate) {
                return -1;
            } else {
                return 0;
            }
        });
        return campaigns;
    }

    public async getCampaigns(campaignUids: string[]): Promise<TCampaign[]> {
        const trips: TCampaign[] = [];

        for (const uid of campaignUids) {
            const trip = await this.getByUid(uid);
            trips.push(trip);
        }
        return trips;
    }

    public async getByDateRange(mmStartingDate: Date, mmEndingDate: Date): Promise<TCampaign[]> {
        const startingDate = mmStartingDate.valueOf();
        const endingDate = mmEndingDate.valueOf();
        const path= this.firestorePathsService.getCampaignsPath();

        const queryOptions: TQueryOptions = {
            collectionPath: path,
            orderByField: 'sentDate',
            orderByDirection: 'asc',  // Use 'asc' for chronological order
            startAt: startingDate,
            endAt: endingDate
        };

        const results = await this.firestoreService.queryCollection(queryOptions) as TCampaign[];
        return results;

        // const results = await this.firestoreService.queryCollection(queryOptions);
        // if (results.length > 0) {
        //     const incentive = results[0] as TCampaign;
        //     if (incentive.sequenceNumber !== undefined) {
        //         largestSequenceNumber = incentive.sequenceNumber;
        //     }
        // }
    }
}
